import { render } from "./GroupSetting.vue?vue&type=template&id=02d21d71&ts=true"
import script from "./GroupSetting.vue?vue&type=script&lang=ts"
export * from "./GroupSetting.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__